<template>
<div class="lead-update-business-card">
  <div class="image_present" v-if="lead.business_card_image_url" @click="openBusinessCard">
    <img :src="lead.business_card_image_url" alt="business card" :onerror="'this.onerror=null; this.src=\'' + this.image + '\';'"/>
  </div>
  <div class="no_image" v-else>
    <img :src="image" alt="no image associated">
  </div>
</div>
</template>
<script>
import image from '@/assets/empty-business-card.svg'
export default {
  data(){
    return {image}
  },
  props: [ 'lead' ],
  methods: {
    openBusinessCard(){
      this.$emit('openBusinessCard')
    }
  }
}
</script>

<style lang="scss" scoped>

.lead-update-monitor.inside-content .lead-update-monitor--business-card{
  margin-top: 1em;
}
.image_present img {
    width: 100%;
}

.no_image img {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// LeadUpdateBusinessCard.vue?3e59d6f6